// extracted by mini-css-extract-plugin
export default {"title":"f1acb28d9e","inner_title":"ed6f5bef2e","charge_btn":"d7de714030"};